import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Dot } from '../styles/Dot';

export const ReactSwipeDots = (props) => {
  const { swipeIndex, numberOfDots } = props;
  const dots = [];
  
  for (let i = 0; i < numberOfDots; i+=1) {
    if (i === swipeIndex) {
      dots.push(<Dot key={i} active />);
    } else {
      dots.push(<Dot key={i} />);
    }
  }
  
  return (
    <Container>
      {dots}
    </Container>
  );
};

const Container = styled.div`
  text-align: center;
  margin: 0 auto;
`;

ReactSwipeDots.defaultProps = {
  swipeIndex: 0,
  numberOfDots: 0,
};

ReactSwipeDots.propTypes = {
  swipeIndex: PropTypes.number,
  numberOfDots: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/ReactSwipeDots.js